<script setup lang="ts">
import { ref } from "vue";
import { RouterLink, useRouter } from "vue-router";
import VueTypewriterEffect from "vue-typewriter-effect";
// import VueTypewriterEffect from 'typewriter-effect/dist/core';

const router = useRouter();

// shall contain html and a link to click (router)
const clickheremsg = ref(
  `<a class="textbtn font-mono text-[80%]" href="${
    router.getRoutes()[1].path
  }">[enter]</a>`
);
</script>

<template>
  <main>
    <img
      src="/img/mm-2.png"
      class="full-img nodrag"
      alt="Home is where the (he)art is."
    />
    <div
      class="centera text-white font-bold leading-none opacity-90 drop-shadow-md"
    >
      <VueTypewriterEffect
        :strings="[
          '<span class=\'font-display select-none\'>murnau<br/>rocks</span>',
          clickheremsg,
          '<span class=\'text-[80%] font-sans select-none cursor-disabled\'>(oﾟvﾟ)ノ<br/>let\'s go!</span>',
        ]"
        :pauseFor="3000"
        delay="natural"
        deleteSpeed="natural"
        :cursor="'•'"
        class="text-center z-10"
      />
    </div>
  </main>
</template>

<style scoped lang="scss">
.textbtn,
.textbtn * {
  font-size: inherit;
}
.full-img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.centera {
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // width: 500px;
  // height: 300px;
  font-size: 8svw;
}
</style>
